import { SupportMemberType } from "@/types/SupportMembersType"
import { StatusEnum } from "@/constants/CodePromoConstants"
import { INCOME_STATUS, MONTHS_NUMBER } from "@/constants/CompaniesConstants"
import { InvoiceStatusEnum } from "@/constants/InvoiceConstants"

export const formatMoney = (amount: number, format = true) => {
  let formattedNumber = amount
  let parts
  if (format) {
    formattedNumber = Math.round(amount ?? 0)
  }
  parts = (formattedNumber ?? 0).toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")

  return parts.join(".")
}


export const getUserFullName = (user: SupportMemberType | undefined, reverse = false, twoLetter = false) => {
  if (!user) return ""
  let last_name = twoLetter ? user?.last_name.split(" ")[0] : user?.last_name
  let first_name = twoLetter ? user?.first_name.split(" ")[0] : user?.first_name
  if (reverse)
    return `${last_name} ${first_name}`
  return `${first_name} ${last_name}`
}

export const generateRandomString = (initials?: string, length: number = 8, charSet?: string) => {
  charSet = charSet || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  let result = initials ? `${initials}_` : ""
  for (let i = 0; i < length; i++) {
    result += charSet.charAt(Math.floor(Math.random() * charSet.length))
  }
  return result
}


export const cleanObject = (obj: { [key: string]: any }) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key]
    }
  })
  return obj
}

export const getFilePath = (fileName: string) => {
  return `${import.meta.env.VITE_MEDIAS_BASE_URL}${fileName}`;
};

export const replaceIdInLink = (id: string, linkPattern: string) => {
  return linkPattern.replace(":id", id);
};

export function kMFormatter(num: number) {
  return Math.abs(num) > 999999?
    (Math.sign(num) * (Math.abs(num) / 1000000)).toFixed(2) + " M":
    Math.abs(num) > 999
    ? (Math.sign(num) * (Math.abs(num) / 1000)).toFixed(2) + " k"
    : (Math.sign(num) * Math.abs(num)).toFixed(2);
}

export const capitalize = (s: string) => {
  let tmp = s.toLowerCase();
  return tmp[0].toUpperCase() + tmp.slice(1);
};

export const getStatusStyle = (status: string) => {
  switch (status) {
    case StatusEnum.ACTIVE:
      return "bg-green-100 text-success"
    case StatusEnum.CANCELLED :
      return "bg-red-100 text-red-500"
    case StatusEnum.SUSPENDED :
      return "bg-red-100 text-red-500"
    case InvoiceStatusEnum.PAID:
      return "bg-green-100 text-success"
    case InvoiceStatusEnum.PARTIALLY_PAID:
      return "bg-c_orange-100 text-c_orange-500"
    case InvoiceStatusEnum.PENDING:
      return "bg-c_orange-100 text-c_orange-500"
    case InvoiceStatusEnum.OVERDUE:
      return "bg-red-100 text-red-500"
    case INCOME_STATUS.on_time:
      return "bg-green-100 text-success"
    case INCOME_STATUS.late :
      return "bg-red-100 text-red-500"
    default:
      return "bg-gray-100 text-gray-500"
  }
}

export const nextSixMonths = () => {
  const monthsArray = [];
  const formatter = new Intl.DateTimeFormat('fr-FR', {
    month: 'long',
    year: 'numeric'
  });

  const currentDate = new Date();

  for (let i = 1; i <= 6; i++) {
    const nextMonthDate = new Date(currentDate);
    nextMonthDate.setMonth(currentDate.getMonth() + i);

    const formattedMonth = formatter.format(nextMonthDate);
    const capitalized = formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
    monthsArray.push(capitalized);
  }

  return monthsArray;
};

export const computeTotalCost = (
  employeesNumber: number,
  costPerEmployee: number,
  paymentFrequency: string,
) => {
  if (employeesNumber <= 5) {
    return costPerEmployee * MONTHS_NUMBER[paymentFrequency]
  }
  return costPerEmployee * employeesNumber * MONTHS_NUMBER[paymentFrequency]
}

export const formatStringUsingRegularPattern = (value: string, pattern: string, separator?: string | undefined) => {
  // "23245" "CC NN"
  const sep = separator || ' ';
  const patternParts = pattern.split(sep) ; // ["CC", "NNN"]
  let formattedString = '';
  let j = 0
  for (let i = 0; i < patternParts.length; i++) {
    formattedString += `${value.substring(j, patternParts[i].length + j)} `;
    // i = 0, "" + "23 ", j = 2
    // i = 1, "23 " + "23 "
    j += patternParts[i].length
  }
  return formattedString;
}

export const formatCnss = (cnss: string) : string =>
  cnss.length == 5
      ? cnss
      : formatStringUsingRegularPattern( cnss, "XX XX XX XX XX XX XX")

export const formatIfu = (ifu: string | null) : string => {
  if (ifu == null) {
    return "Néant"
  }else {
    return formatStringUsingRegularPattern(ifu, "X XXXX XXXX XXXX")
  }
}

export const BJPREFIX = ["46", "47", "48", "62", "21", "22", "23"];